'use client';
import { css } from 'styled-components';
import { fromMd } from '../../constants';
import { skeletonAnimationCss } from '../Skeleton';
const getTypeStyleCssFunction = (props) => {
    return css(o => {
        const typographyTokens = props.type === 'headline'
            ? o.theme.typography.headline[props.name]
            : o.theme.typography.body[props.name];
        const overrideAttributes = {
            ...(o.$isUppercase && o.theme.typography.effect.uppercase
                ? o.theme.typography.effect.uppercase
                : {}),
            ...(o.$fontWeight ? { fontWeight: o.$fontWeight } : {}),
        };
        const fromMdAttributes = typographyTokens.fromMd.fontSize !== typographyTokens.untilMd.fontSize
            ? {
                [fromMd]: {
                    ...typographyTokens.fromMd,
                    ...overrideAttributes,
                },
            }
            : {};
        return {
            ...typographyTokens.untilMd,
            ...overrideAttributes,
            ...fromMdAttributes,
        };
    });
};
export const typeStyleMap = {
    headlineExtraLarge: getTypeStyleCssFunction({ type: 'headline', name: 'extraLarge' }),
    headlineLarge: getTypeStyleCssFunction({ type: 'headline', name: 'large' }),
    headlineMedium: getTypeStyleCssFunction({ type: 'headline', name: 'medium' }),
    headlineSmall: getTypeStyleCssFunction({ type: 'headline', name: 'small' }),
    headlineExtraSmall: getTypeStyleCssFunction({ type: 'headline', name: 'extraSmall' }),
    headlineExtraExtraSmall: getTypeStyleCssFunction({ type: 'headline', name: 'extraExtraSmall' }),
    headlineMicro: getTypeStyleCssFunction({ type: 'headline', name: 'micro' }),
    eyebrow: css `
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.15em;
    line-height: 1.7;

    ${fromMd} {
      font-size: 14px;
    }
  `,
    bodyDefault: getTypeStyleCssFunction({ type: 'body', name: 'default' }),
    bodyLarge: getTypeStyleCssFunction({ type: 'body', name: 'large' }),
    bodyMedium: getTypeStyleCssFunction({ type: 'body', name: 'medium' }),
    bodySmall: getTypeStyleCssFunction({ type: 'body', name: 'small' }),
    bodyMicro: getTypeStyleCssFunction({ type: 'body', name: 'micro' }),
    bodyNano: getTypeStyleCssFunction({ type: 'body', name: 'nano' }),
    bodyTiny: getTypeStyleCssFunction({ type: 'body', name: 'tiny' }),
};
const getTypeStyleSkeletonCssFunction = (props) => {
    return css(o => {
        const typographyTokens = props.type === 'headline'
            ? o.theme.typography.headline[props.name]
            : o.theme.typography.body[props.name];
        return {
            display: 'block',
            height: typographyTokens.untilMd.fontSize,
            marginTop: `calc((${typographyTokens.untilMd.lineHeight} - 1) * ${typographyTokens.untilMd.fontSize})`,
            [fromMd]: {
                height: typographyTokens.fromMd.fontSize,
                marginTop: `calc((${typographyTokens.fromMd.lineHeight} - 1) * ${typographyTokens.fromMd.fontSize})`,
            },
        };
    }, skeletonAnimationCss);
};
export const typeStyleSkeletonMap = {
    headlineExtraLarge: getTypeStyleSkeletonCssFunction({ type: 'headline', name: 'extraLarge' }),
    headlineLarge: getTypeStyleSkeletonCssFunction({ type: 'headline', name: 'large' }),
    headlineMedium: getTypeStyleSkeletonCssFunction({ type: 'headline', name: 'medium' }),
    headlineSmall: getTypeStyleSkeletonCssFunction({ type: 'headline', name: 'small' }),
    headlineExtraSmall: getTypeStyleSkeletonCssFunction({ type: 'headline', name: 'extraSmall' }),
    headlineExtraExtraSmall: getTypeStyleSkeletonCssFunction({
        type: 'headline',
        name: 'extraExtraSmall',
    }),
    headlineMicro: getTypeStyleSkeletonCssFunction({ type: 'headline', name: 'micro' }),
    eyebrow: css `
    ${skeletonAnimationCss};
    display: block;
    height: 12px;
    margin-top: calc(0.7 * 12px);

    ${fromMd} {
      height: 12px;
      margin-top: calc(0.7 * 14px);
    }
  `,
    bodyDefault: getTypeStyleSkeletonCssFunction({ type: 'body', name: 'default' }),
    bodyLarge: getTypeStyleSkeletonCssFunction({ type: 'body', name: 'large' }),
    bodyMedium: getTypeStyleSkeletonCssFunction({ type: 'body', name: 'medium' }),
    bodySmall: getTypeStyleSkeletonCssFunction({ type: 'body', name: 'small' }),
    bodyMicro: getTypeStyleSkeletonCssFunction({ type: 'body', name: 'micro' }),
    bodyNano: getTypeStyleSkeletonCssFunction({ type: 'body', name: 'nano' }),
    bodyTiny: getTypeStyleSkeletonCssFunction({ type: 'body', name: 'tiny' }),
};
//# sourceMappingURL=fixtures.js.map